


































import { defineComponent } from '@vue/composition-api';
import { MultiJumpContainer } from '@tencent/wphk-components-multi-jump-container';

export default defineComponent({
  name: 'Banner',
  components: {
    MultiJumpContainer,
  },
  props: {
    bannerInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    return {};
  },
});
